'use client'

import { Button, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/shared/i18n'

import { useTracking } from '@marketplace-web/shared/event-tracker'
import { Screen } from 'constants/tracking/screens'
import { clickEvent } from '_libs/common/event-tracker/events'
import { ClickableElement } from 'constants/tracking/clickable-elements'

const ClosingSection = () => {
  const translate = useTranslate('item_verification')
  const { track } = useTracking()

  const trackClickEvent = (target: ClickableElement, url: string) => {
    track(
      clickEvent({
        screen: Screen.ItemVerification,
        target,
        targetDetails: `closing_section__${url}`,
      }),
    )
  }

  return (
    <section className="item-verification__closing" data-testid="closing">
      <div className="item-verification__closing-content">
        <h2 className="item-verification__closing-title">{translate('closing.title')}</h2>
        <p className="item-verification__closing-description">{translate('closing.description')}</p>
        <div className="item-verification__closing-actions">
          <Button
            url={translate('url.cta')}
            styling={Button.Styling.Filled}
            inverse
            onClick={() => trackClickEvent(ClickableElement.CtaRedirect, translate('url.cta'))}
            testId="closing-main_cta"
          >
            {translate('actions.primary')}
          </Button>
          <Text as="span">
            <a
              href={translate('url.help')}
              className="item-verification__closing-link"
              onClick={() => trackClickEvent(ClickableElement.Hyperlink, translate('url.help'))}
              data-testid="closing-secondary_cta"
            >
              {translate('actions.secondary')}
            </a>
          </Text>
        </div>
      </div>
    </section>
  )
}

export default ClosingSection
